// Deployment environment identity, sourced at runtime from the container's
// NODE_ENV and surfaced to SPA clients via window.__ENV__.app.environment.
// Values are lowercase to match the NODE_ENV wire strings, so key !== value here.
export enum EnvironmentEnum {
  Development = 'development',
  Beta = 'beta',
  Production = 'production',
}
